import { render, staticRenderFns } from "./RequestKits.vue?vue&type=template&id=60e96992&scoped=true"
import script from "./RequestKits.vue?vue&type=script&lang=js"
export * from "./RequestKits.vue?vue&type=script&lang=js"
import style0 from "./RequestKits.vue?vue&type=style&index=0&id=60e96992&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e96992",
  null
  
)

export default component.exports